<script setup lang="ts">
import { Settings } from 'lucide-vue-next'
</script>

<template>
  <Settings />
</template>
